import { useCallback, useMemo } from 'react';
import * as Yup from 'yup';

export const useYearsInCurrentCompanyFilter = ({ setFilters }) => {
  const formSchema = useMemo(
    () =>
      Yup.object().shape({
        yearsInCurrentCompany: Yup.object().nullable(),
      }),
    [],
  );

  const onSubmit = useCallback(
    (values) => {
      const rangeValues = values.yearsInCurrentCompany;
      const filterValue = rangeValues
        ? {
            years_in_current_company_gteq: rangeValues.min,
            years_in_current_company_lteq: rangeValues.max,
          }
        : null;

      setFilters({ yearsInCurrentCompany: filterValue });
    },
    [setFilters],
  );

  return {
    formSchema,
    onSubmit,
  };
};
